import "../../../../assets/css/screens/admin/dashboard/earnings/AdminEarnings.css";
import React, { useState, useEffect ,useContext} from 'react';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import { TrendingUp, TrendingDown, CreditCard, DollarSign, Clock, ArrowRight, Download } from 'lucide-react';

/* ══ Animated counter ══ */
const useCount = (target, duration = 1400) => {
  const [val, setVal] = useState(0);
  useEffect(() => {
    const num = parseFloat(String(target).replace(/[^0-9.]/g,'')) || 0;
    if(!num) return;
    const step = num / (duration / 16);
    let cur = 0;
    const t = setInterval(() => {
      cur += step;
      if(cur >= num){ setVal(num); clearInterval(t); }
      else setVal(cur);
    }, 16);
    return () => clearInterval(t);
  }, [target]);
  if(String(target).includes('%')) return '+' + Math.round(val) + '%';
  if(String(target).includes('$')) return '$' + Math.round(val).toLocaleString();
  return Math.round(val).toLocaleString();
};



const TRANSACTIONS = [
 
];

const TYPE_CFG = {
  'Booking Payment': { color:'#fff', bg:'linear-gradient(135deg,#0491e1,#0672b5)' },
  'Payout':          { color:'#fff', bg:'linear-gradient(135deg,#f59e0b,#d97706)' },
  'Refund':          { color:'#fff', bg:'linear-gradient(135deg,#ef4444,#dc2626)' },
};

const STATUS_CFG = {
  Completed: { color:'#fff', bg:'linear-gradient(135deg,#10b981,#059669)' },
  Pending:   { color:'#fff', bg:'linear-gradient(135deg,#f59e0b,#d97706)' },
  Processed: { color:'#fff', bg:'linear-gradient(135deg,#8b5cf6,#7c3aed)' },
};

/* ── Stat Card ── */
const StatCard = ({ stat, idx }) => {
  const Icon = stat.icon;
  const display = useCount(stat.value);
  return (
    <div className="earn-stat" style={{background:stat.bg,'--es-shadow':stat.shadow,animationDelay:idx*0.09+'s'}}>
      <div className="earn-stat__circle"/>
      <div className="earn-stat__top">
        <div className="earn-stat__icon"><Icon size={22}/></div>
        <span className={'earn-stat__change'+(stat.up?' earn-stat__change--up':' earn-stat__change--down')}>
          {stat.up?<TrendingUp size={12}/>:<TrendingDown size={12}/>} {stat.change}
        </span>
      </div>
<div className="earn-stat__value">
  {display} USD
</div>      <div className="earn-stat__label">{stat.label}</div>
    </div>
  );
};

const AdminEarnings = () => {
  const [filter, setFilter] = useState('All');
  // const types = ['All','Booking Payment','Payout','Refund'];
    const {baseUrl, authToken} = useContext(AppContext);

 const [totalRevenue, setTotalRevenue] = useState(0);
const [platformFee, setPlatformFee] = useState(0);
const [pendingPayouts, setPendingPayouts] = useState(0);
const [refunds,setRefunds] = useState(0);
  const [jobs, setJobs] = useState([]);
  const STATS = [
  {
    icon: CreditCard,
    bg:'linear-gradient(135deg,#0491e1 0%,#0672b5 100%)',
    shadow:'rgba(4,145,225,0.38)',
    value:`$${totalRevenue}`,
    label:'Total Revenue',
    change:'+12%',
    up:true
  },
  {
    icon: DollarSign,
    bg:'linear-gradient(135deg,#0491e1 0%,#0672b5 100%)',
    shadow:'rgba(4,145,225,0.38)',
    value:`$${platformFee}`,
    label:'Platform Fee',
    change:'+8%',
    up:true
  },
  {
    icon: Clock,
    bg:'linear-gradient(135deg,#0491e1 0%,#0672b5 100%)',
    shadow:'rgba(4,145,225,0.38)',
    value:`$${pendingPayouts}`,
    label:'Pending Payouts',
    change:'-3%',
    up:false
  },
 {
 icon: TrendingDown,
 bg:'linear-gradient(135deg,#0491e1 0%,#0672b5 100%)',
 shadow:'rgba(4,145,225,0.38)',
 value:`$${refunds}`,
 label:'Refunds',
 change:'-5%',
 up:false
}
];
useEffect(() => {


  axios.get(`${baseUrl}/admin/platform-fee`, {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
.then((res)=>{

setTotalRevenue(res.data.totalRevenue);

setPlatformFee(res.data.platformFee);

setPendingPayouts(res.data.pendingPayouts);

setRefunds(res.data.refunds);

setJobs(res.data.jobs);
  console.log("EARNINGS DATA:", res.data.jobs);

    setJobs(res.data.jobs);

})
  .catch((err) => {
    console.log(err.response?.data || err.message);
  });

}, []);
const filtered = jobs.filter(t => filter === 'All' || t.serviceType === filter);

  return (
    <div className="earn-page">

      {/* ── Header ── */}
      <div className="earn-header">
        <div>
          <h2 className="earn-title">Earnings</h2>
          <p  className="earn-sub">Revenue &amp; transaction overview</p>
        </div>
        {/* <button className="earn-export">
          <Download size={15}/> Export CSV
        </button> */}
      </div>

      {/* ── Stat Cards ── */}
      <div className="earn-stats">
        {STATS.map((s,i) => <StatCard key={s.label} stat={s} idx={i}/>)}
      </div>

      {/* ── Transactions ── */}
      <div className="earn-card">
        <div className="earn-card__header">
          <h5 className="earn-card__title">Completed Jobs</h5>
          {/* <div className="earn-filters">
            {types.map(t => (
              <button key={t} className={'earn-filter-btn'+(filter===t?' earn-filter-btn--active':'')} onClick={()=>setFilter(t)}>{t}</button>
            ))}
          </div> */}
        </div>

        {/* Desktop table */}
        <div className="earn-table-wrap">
          <table className="earn-table">
            <thead>
              <tr><th>ID</th><th>Provider</th><th>Type</th><th>Amount</th><th>Fee</th><th>Date</th><th>Status</th></tr>
            </thead>
            <tbody>
              {filtered.map((t,i) => {
                const tc = TYPE_CFG[t.serviceType]||TYPE_CFG['Booking Payment'];
                const sc = STATUS_CFG[t.status]||STATUS_CFG.Completed;
                return (
                  <tr key={t.id} className="earn-tr" style={{animationDelay:i*0.06+'s'}}>
                    <td className="earn-td-id">{t.id}</td>
<td><strong>{t.whserviceprovider?.fullName || "Not Assigned"}</strong></td>                   
<td>
  <span className="earn-badge" style={{color:tc.color,background:tc.bg}}>
    {t.whcategory?.name || "N/A"}
  </span>
</td>                    <td className="earn-td-amount">{t.budget}</td>
                    <td className="earn-td-fee">{t.platform_fee}</td>
                    <td className="earn-td-date">{t.deadline}</td>
                    <td><span className="earn-badge" style={{color:sc.color,background:sc.bg}}>{t.status}</span></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Mobile cards */}
        <div className="earn-mob-list">
          {filtered.map((t,i) => {
            const tc = TYPE_CFG[t.serviceType]||TYPE_CFG['Booking Payment'];
            const sc = STATUS_CFG[t.status]||STATUS_CFG.Completed;
            return (
              <div key={t.id} className="earn-mob-card" style={{animationDelay:i*0.07+'s'}}>
                <div className="earn-mob-card__top">
                  <span className="earn-td-id">{t.id}</span>
                  <span className="earn-badge" style={{color:sc.color,background:sc.bg}}>{t.status}</span>
                </div>
                <div className="earn-mob-card__mid">
              <strong>{t.whserviceprovider?.fullName}</strong>
                  <span className="earn-td-amount">{t.budget}</span>
                </div>
                <div className="earn-mob-card__bot">
                  <span className="earn-badge" style={{color:tc.color,background:tc.bg}}>{t.serviceType}</span>
                  <span className="earn-td-date">{t.deadline}</span>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </div>
  );
};

export default AdminEarnings;